const Index = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
    routes: [
        {
            path: '/awar/rept/index',
            name: 'awar_rept_index',
            component: Index
        }
    ]
}
